import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import ProjectFour from '../components/project/ProjectFour';
import FooterOne from '../common/footer/FooterOne';

const PortfolioPage = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb 
                heading="Gallery"
                currentPage="Gallery" 
            />
            <ProjectFour />
            <FooterOne />
        </>
    )
}

export default PortfolioPage;
